
import lazyInject from '@/di';
import { AgentService } from '@/services/agent.service';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CarService from '@/services/car.service';

@Component({})
export default class CarSalesmanChange extends Vue {
  confirmLoading = false;

  isVisible = false;

  staffTemp = [];

  agentStaff: Array<{
    id: number;
    username: string;
    phone: string;
  }> = [];

  form: {
    reason: string;
    staffId: number;
    previousStaffName: string;
    order_no: number;
    shopName: string;
  } = {
      reason: '',
      staffId: -1,
      previousStaffName: '',
      order_no: -1,
      shopName: '',
    };

  @Prop({})
  order!: any;

  @Watch('order', { deep: true, immediate: true })
  watchOrder() {
    if (this.order != null) {
      this.$set(this.form, 'previousStaffName', this.order.staff);
      this.$set(this.form, 'order_no', this.order.order_no);
      this.$set(this.form, 'shopName', this.order.shop_name);
    }
  }

  @lazyInject(AgentService)
  protected agentService!: AgentService;

  @lazyInject(CarService)
  carService!: CarService;

  open() {
    this.staff();
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
    this.$emit('close');
    this.reset();
  }

  reset() {
    this.form = {
      reason: '',
      staffId: -1,
      previousStaffName: '',
      shopName: '',
      order_no: -1,
    };
    this.staffTemp = [];
  }

  async staff() {
    const res = await this.carService.postShopOrderStaff();
    if (res && res.length > 0) {
      this.agentStaff = res;
    }
  }

  onChange(nameAndPhone: string) {
    const phone = nameAndPhone.split('|')[1];

    const person: any = this.agentStaff.filter((item) => {
      return item.phone === phone;
    })[0];

    if (this.form.staffId === person.user_id) {
      return;
    }
    this.$set(this.form, 'staffId', person.user_id);
  }

  async handleOk() {
    if (!this.form.order_no || this.form.order_no === -1) {
      return;
    }
    // console.log(this.form);

    if (this.form.staffId === -1 || !this.form.staffId) {
      this.$message.warn('请选择地推人员。');
      return;
    }

    if (!this.form.reason) {
      this.$message.warn('变更原因不能为空！');
      return;
    }

    const res = await this.carService.postShopOrderEditStaff({
      order_no: this.form.order_no,
      staff_id: this.form.staffId,
      remark: this.form.reason,
    });

    if (!res) return;
    this.$message.success(res);
    this.$emit('refresh');
    this.close();
  }

  mounted() {
    // this.staff();
  }
}
